import { MedicineForListModel } from '../medicineForListModel';
import { UserMedicineHistoryModel } from './userMedicineHistoryModel';

export class UserMedicineModel {
  public userId: number;
  public medicine: MedicineForListModel;
  public userMedicineHistory: Array<UserMedicineHistoryModel>;
}